module.exports = __webpack_public_path__ + "static/media/_base.518be74d.scss";


//////////////////
// WEBPACK FOOTER
// ./src/assets/style/_base.scss
// module id = 587
// module chunks = 0